import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Typography,
  FormControl,
  Select,
  MenuItem,
  Box,
  IconButton,
} from "@mui/material";
import { FilterList } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import {
  useCurrentPageActionContext,
  useCurrentPageContext,
  useMainGridSortActionContext,
} from "../../../Context/GlobalContext";
import {
  useItemSelectedFilterActionsContext,
  useSelectedFilterActionsContext,
  useSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import { useLanguageContext } from "../../../Context/LanguageContext";

export default function SearchTopBar({
  saveFilterList,
  setConditions,
  reportCode,
  handleDelFilterSuccess,
  isShowSaveFilterDropDown,
  hasReset,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [selectedFilterID, setSelectedFilterID] = useState("");
  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdateSortBy = useMainGridSortActionContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();
  const currentPage = useCurrentPageContext();
  const selectedFilter = useSelectedFilterContext();

  const handleFilterChange = (_id) => {
    updateSelectedFilter((prev) => {
      if (_id === "" && prev !== "") {
        return "";
      } else {
        return saveFilterList.filter((filter) => filter.id === _id);
      }
    });
    if (_id !== "") {
      GridColumn_SettingActions.getSaveFilterValue(_id, reportCode);
    } else {
      setConditions([{ Name: "", Operator: "", Value: "" }]);
    }
    // if (currentPage !== 1) {
    //   UpdateCurrentPage(1);
    // } else {
    //   UpdateSortBy("InventarNr");
    // }
  };

  const handleDelete = () => {
    setGlobalSpinner(true);

    GridColumn_SettingActions.deleteSavedFilter(selectedFilterID, reportCode);
  };

  useEffect(() => {
    if (selectedFilter !== "") {
      setSelectedFilterID(selectedFilter[0]["id"]);
    }
  }, [selectedFilter]);

  useEffect(() => {
    function getDelSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilDelResult();
      setConditions([{ Name: "", Operator: "", Value: "" }]);
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      setSelectedFilterID("");
      toast.success(localization.delSuccess);
      handleDelFilterSuccess();
    }

    function getDelSaveFilterResultFailure() {
      const res = gridColSettingStore.getsaveFilDelResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_SUCCESS,
      getDelSaveFilterResultSuccess
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER__FAILURE,
      getDelSaveFilterResultFailure
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_SUCCESS,
        getDelSaveFilterResultSuccess
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER__FAILURE,
        getDelSaveFilterResultFailure
      );
    };
  }, []);

  useEffect(() => {
    if (hasReset) {
      setSelectedFilterID("");
    }
  }, [hasReset]);
  return (
    <>
      <Box className="filterTopBar">
        <Box display="flex" alignItems="center" gap={2}>
          <FilterList />
          <Typography variant="h4">{localization.filter}</Typography>
        </Box>
        {isShowSaveFilterDropDown && (
          <Box className="filterTopBarRight" sx={{ width: "30%" }}>
            <FormControl variant="outlined" fullWidth>
              <Select
                disabled={saveFilterList.length === 0}
                displayEmpty
                value={selectedFilterID}
                onChange={(e) => {
                  setSelectedFilterID(e.target.value);
                  updateListSelectedFilter([]);
                  handleFilterChange(e.target.value);
                }}
                fullWidth
                sx={{ height: "38px" }}
              >
                <MenuItem value="">{localization.filterPlaceholder}</MenuItem>
                {saveFilterList.length > 0 &&
                  saveFilterList.map((item, index) => (
                    <MenuItem value={item.id} key={index}>
                      {item.title}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <IconButton
              color="error"
              disabled={selectedFilterID === ""}
              onClick={handleDelete}
              sx={{ height: "38px" }}
              title={localization.delete}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        )}
      </Box>
      <Typography variant="body1">{localization.filterHeaderTop}</Typography>
    </>
  );
}
